<nz-modal
  #modalRef
  nzSize
  [(nzVisible)]="isVisible"
  [nzTitle]="(isEdit ? 'Edit' : 'Add') + ' Dietary Habits' | translate"
  (nzOnCancel)="handleCancel()"
  nzCancelText="Cancel"
  nzOkText="Save"
  nzOkType="primary"
  [nzFooter]="null"
  class="custom-modal-class"
  >
  <ng-container *nzModalContent>
    <form
      [formGroup]="dietaryHabitsForm"
      (ngSubmit)="submitForm()"
      [ngClass]="{
        'social-submitted': dietaryHabitsSubmitted,
        'social-not-submitted': !dietaryHabitsSubmitted
      }"
      >
      <!-- Dietary Habits Dropdown -->
      <div class="form-row" fxLayout="row" fxLayoutAlign="start center">
        <div fxLayout="col" fxLayoutAlign="start center" fxFlex="30">
          <label>{{ "Dietary Habit" | translate }}</label>
        </div>
        <div fxLayout="col" fxLayoutAlign="start center" fxFlex="70">
          <nz-select
            class="inputs social"
            nzShowSearch
            nzAllowClear
            [nzPlaceHolder]="'Dietary Habit' | translate"
            formControlName="dietaryHabitsIdValue"
            [nzLoading]="isLoading"
            >
            @for (et of dietaryHabitsDropdown; track et) {
              <nz-option [nzLabel]="et.name" [nzValue]="et.id"></nz-option>
            }
          </nz-select>
        </div>
      </div>

      <!-- Timing Unit Dropdown -->
      <div class="form-row" fxLayout="row" fxLayoutAlign="start center">
        <div fxLayout="col" fxLayoutAlign="start center" fxFlex="30">
          <label>{{ "Timing Unit" | translate }}</label>
        </div>
        <div fxLayout="col" fxLayoutAlign="start center" fxFlex="70">
          <nz-select
            class="inputs social"
            nzShowSearch
            nzAllowClear
            [nzPlaceHolder]="'Timing Unit' | translate"
            formControlName="customTimingUnitIdValue"
            [nzLoading]="isLoading"
            >
            @for (et of timingUnitDropdown; track et) {
              <nz-option [nzLabel]="et.name" [nzValue]="et.id"></nz-option>
            }
          </nz-select>
        </div>
      </div>

      <!-- Unit Amount -->
      <div class="form-row" fxLayout="row" fxLayoutAlign="start center">
        <div fxLayout="col" fxLayoutAlign="start center" fxFlex="30">
          <label>{{ "Unit Amount" | translate }}</label>
        </div>
        <div fxLayout="col" fxLayoutAlign="start center" fxFlex="70">
          <input
            nz-input
            class="inputs social"
            type="number"
            [placeholder]="'Unit Amount ...' | translate"
            formControlName="unitAmountValue"
            min="0"
            />
          </div>
        </div>

        <!-- Description -->
        <div class="form-row" fxLayout="row" fxLayoutAlign="start center">
          <div fxLayout="col" fxLayoutAlign="start center" fxFlex="30">
            <label>{{ "Description" | translate }}</label>
          </div>
          <div fxLayout="col" fxLayoutAlign="start center" fxFlex="70">
            <textarea
              nz-input
              rows="4"
              class="inputs social"
              [placeholder]="'Description ...' | translate"
              formControlName="descriptionValue"
            ></textarea>
          </div>
        </div>

        <!-- Footer buttons -->
        <div fxLayout="row" fxLayoutAlign="end" class="footer">
          <button
            nz-button
            nzPrimary
            class="save-btn"
            type="submit"
            [nzLoading]="isLoading"
            [disabled]="isLoading"
            >
            {{ "Save" | translate }}
          </button>
          <button
            nz-button
            nzDanger
            class="cancel-btn"
            type="button"
            (click)="handleCancel()"
            [disabled]="isLoading"
            >
            {{ "Cancel" | translate }}
          </button>
        </div>
      </form>
    </ng-container>
  </nz-modal>
